import { useEffect, useMemo, useState } from 'react'
import HttpClient from '../../../utils/HttpClient';
import { useUserData } from '../../../Providers/UserWrapper';
import fisiIconDrop from "../../../images/FisTaskIcon.png";
import TaskPopUp from '../TaskPopUp';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useLanguage } from '../../../Providers/LanguageContext';
import Select from 'react-select';
import './DeleteModal.css';
import timezones from 'timezones-list';
import { formatDateForInput } from '../../../utils/convertDateToTimezone';

const TaskSidebar = ({ getTaskData, taskAllData, setModala, setTaskDetailData, selectAssignUserMemo, entireTaskData, fetchEntireTask }) => {
    const { language, currentLanguage } = useLanguage();
    const { isMainUserMemo, profileData } = useUserData();
    const [isEdit, setIsEdit] = useState(false);
    const [taskId, setTaskId] = useState(null);

    // Get timezone list and format for Select component
    // Add timezone options formatting
    const timezoneOptions = useMemo(() => {
        return timezones.map(tz => ({
            value: tz.tzCode,
            label: `${tz.label} (${tz.name})`
        }));
    }, []);

    // Helper function to convert local date and time to timezone-aware ISO string
    const convertToTimezoneISO = (dateString, timeString, timezone) => {
        if (!dateString || !timeString || !timezone) return null;

        try {
            // Create a date string in ISO format but in local time
            const localDateString = `${dateString}T${timeString}`;
            const localDate = new Date(localDateString);

            // Format this date in the target timezone
            const timezonedDateString = new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).format(localDate);

            // Parse the formatted string back to a Date object
            const [month, day, year] = timezonedDateString.split('/');
            const [hour, minute] = timezonedDateString.split(', ')[1].split(':');

            // Create ISO string in UTC
            const utcDate = new Date(Date.UTC(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hour),
                parseInt(minute)
            ));

            return utcDate.toISOString();
        } catch (error) {
            console.error('Error converting date to timezone:', error);
            return null;
        }
    };

    const convertDateToTimezone = (dateString, timezone) => {
        if (!dateString || !timezone) return dateString;

        try {
            const date = new Date(dateString);
            // Convert to timezone-specific string
            return new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(date);
        } catch (error) {
            console.error('Error converting date:', error);
            return dateString;
        }
    };
    const initSelectData = { value: "", label: "" }
    const initTask = {
        date: "",
        startTime: "",
        endTime: "",
        taskName: "",
        taskNote: "",
        taskStatus: "",
        assignedUser: [],
        assignedProject: null,
        endDate: '',
        timezone: '', // Add timezone field
    }

    const [formData, setFormData] = useState(initTask);
    const [assignProjectData, setAssignProjectData] = useState([]);
    const [searchedData, setSearchedData] = useState(initSelectData);

    // Add these state variables for delete confirmation
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteConfirmText, setDeleteConfirmText] = useState('');
    const [projectToDelete, setProjectToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);


    // Delete confirmation handler
    const handleDeleteClick = (task) => {
        setProjectToDelete(task);
        setDeleteModalOpen(true);
        setDeleteConfirmText('');
    };

    // Confirm delete action
    const confirmDelete = async () => {
        if (deleteConfirmText.toLowerCase() !== 'delete') {
            toast.error('Please type "delete" to confirm');
            return;
        }

        setDeleting(true);
        try {
            await handleDeleteTaskById(projectToDelete._id);
            setDeleteModalOpen(false);
            setProjectToDelete(null);
            setDeleteConfirmText('');
        } catch (error) {
            toast.error('Failed to delete task');
        } finally {
            setDeleting(false);
        }
    };

    const clearState = () => {
        setFormData(initTask);
    };

    const searchSelectOptionMemo = useMemo(() => {
        return entireTaskData?.map((item) => ({
            value: item,
            label: item?.taskName
        }))
    }, [entireTaskData])

    // Helper function to format assignToUser for Select component
    const formatAssignToUser = (userIds) => {
        if (!userIds || !Array.isArray(userIds)) return [];

        return userIds.map(userId => {
            const user = selectAssignUserMemo?.find(item => item.value === userId);
            return user || { value: userId, label: `User ${userId}` };
        });
    };

    // Helper function to format date for input[type="date"]
    // const formatDateForInput = (dateString) => {
    //     if (!dateString) return "";
    //     return moment(dateString).format('YYYY-MM-DD');
    // };

    // change 
    const handleTaskChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    // validate
    const validate = () => {
        if (!formData.date) {
            toast.error("Date is Required");
            return true
        }
        if (!formData.endDate) {
            toast.error("End Date is Required");
            return true
        }
        if (!formData.startTime) {
            toast.error("Start Time is Required");
            return true
        }
        if (!formData.endTime) {
            toast.error("End Time is Required");
            return true
        }
        if (!formData.taskName) {
            toast.error("Task Name is Required");
            return true
        }
        if (!formData.taskNote) {
            toast.error("Task Note is Required");
            return true
        }
        return false;
    }

    // click on post
    const handlePost = async (e) => {
        e.preventDefault();
        if (validate()) return;

        try {
            const assignedUserIds = isMainUserMemo
                ? formData?.assignedUser?.map(user => user.value)
                : [profileData?._id];

            // Convert dates to timezone-aware ISO strings
            const convertedStartDate = convertDateToTimezone(formData.date, formData.timezone);
            const convertedEndDate = convertDateToTimezone(formData.endDate, formData.timezone);

            const data = {
                assignToUser: assignedUserIds,
                taskName: formData?.taskName,
                taskNotes: formData?.taskNote,
                taskStatus: formData?.taskStatus ? formData.taskStatus : 'open',
                // selectDate: moment(formData?.date).format('YYYY-MM-DD'),
                // endDate: moment(formData?.endDate).format('YYYY-MM-DD'),
                selectDate: convertedStartDate,
                endDate: convertedEndDate,
                startTime: formData?.startTime,
                endTime: formData?.endTime,
                assignToProject: formData?.assignedProject,
                timeZone: formData?.timezone,
            };

            const res = await HttpClient.requestData("add-task-eventDetails", "POST", data)
            if (res && res?.status) {
                toast.success("Task Added Successfully");
                clearState();
                getTaskData();
                fetchEntireTask();
            } else {
                console.log(res?.message || "something wrong");
            }
        } catch (error) {
            toast.error(error?.message || 'something ')
        }
    };


    // click on update
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (validate()) return;

        try {
            const assignedUserIds = isMainUserMemo
                ? formData?.assignedUser?.map(user => user.value)
                : [profileData?._id];

            // Convert dates to timezone-aware ISO strings
            const convertedStartDate = convertDateToTimezone(formData.date, formData.timezone);
            const convertedEndDate = convertDateToTimezone(formData.endDate, formData.timezone);

            const data = {
                assignToUser: assignedUserIds,
                taskName: formData?.taskName,
                taskNotes: formData?.taskNote,
                taskStatus: formData?.taskStatus ? formData.taskStatus : 'open',
                // selectDate: moment(formData?.date).format('YYYY-MM-DD'),
                // endDate: moment(formData?.endDate).format('YYYY-MM-DD'),
                selectDate: convertedStartDate,
                endDate: convertedEndDate,
                startTime: formData?.startTime,
                endTime: formData?.endTime,
                assignToProject: formData?.assignedProject,
                timeZone: formData?.timezone,
            };

            const res = await HttpClient.requestData("update-task-eventDetails/" + taskId, "PUT", data)
            if (res && res?.status) {
                toast.success("Task Updated Successfully");
                clearState();
                getTaskData();
                fetchEntireTask();
            } else {
                console.log(res?.message || "something wrong");
            }
        } catch (error) {
            toast.error(error?.message || 'something ')
        }
    };

    const handleDeleteTaskById = async (id) => {
        try {
            const res = await HttpClient.requestData("delete-task-eventDetails/" + id, "DELETE");
            if (res && res?.status) {
                toast.success(res?.message || "Task Deleted Successfully");
                getTaskData();
                fetchEntireTask();
            } else {
                console.log(res?.message || "something went wrong!!!");
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
        }
    };

    // getting assigned projects
    const getAssignedProject = async () => {
        const res = await HttpClient.requestData("view-all-project", "GET")
        if (res && res?.status) {
            setAssignProjectData(res?.data);
        }
    }

    useEffect(() => {
        getAssignedProject()
    }, []);

    return (
        <div>
            {/* form */}
            <form action="" className="taskEvForm">
                <div>
                    <div className="taskMainInpDiv">
                        {/* search */}
                        <div className="taskTabInps22">
                            <Select
                                className="taskUpperInpSearch"
                                placeholder={language.search}
                                isClearable={true}
                                isSearchable={true}
                                value={searchedData?.value === "" ? null : searchedData}
                                options={searchSelectOptionMemo}
                                onChange={e => {
                                    if (e) {
                                        setSearchedData({ value: e.value, label: e.value?.taskName });
                                        setTaskDetailData(e.value);

                                        // Format assignToUser for the Select component
                                        const formattedAssignToUser = formatAssignToUser(e.value?.assignToUser);

                                        // Format dates for date inputs
                                        const formattedStartDate = formatDateForInput(e.value?.selectDate);
                                        const formattedEndDate = formatDateForInput(e.value?.endDate);

                                        setFormData({
                                            date: formattedStartDate,
                                            startTime: e?.value?.startTime || "",
                                            endTime: e?.value?.endTime || "",
                                            taskName: e?.value?.taskName || "",
                                            taskNote: e?.value?.taskNotes || "",
                                            taskStatus: e?.value?.taskStatus || "",
                                            assignedUser: formattedAssignToUser,
                                            assignedProject: e?.value?.assignToProject || null,
                                            endDate: formattedEndDate,
                                            timezone: e?.value?.timeZone,
                                        });
                                        setIsEdit(true);
                                        setTaskId(e.value._id);
                                    } else {
                                        setSearchedData(initSelectData);
                                        setFormData(initTask);
                                    }
                                }}
                            />
                            <i className="fa-solid fa-magnifying-glass taskSearGlass" style={{ left: "108px" }}></i>
                        </div>
                    </div>

                    {/* Timezone Selection */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder={language.Select_Timezone}
                            isClearable={true}
                            isSearchable={true}
                            name="timezone"
                            options={timezoneOptions}
                            value={timezoneOptions.find(option => option.value === formData.timezone) || null}
                            onChange={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    timezone: selectedOption ? selectedOption.value : "",
                                }));
                            }}
                        />
                    </div>

                    <div className="taskMainInpDiv">
                        {/* date */}
                        <div className="taskTabInps">
                            <input
                                type="date"
                                placeholder={language.date}
                                className="taskSearInp"
                                name="date"
                                value={formData.date}
                                onChange={(e) => handleTaskChange(e)}
                            />
                        </div>

                        {/* end date */}
                        <div className="taskTabInps">
                            <input
                                type="date"
                                placeholder={language.date}
                                className="taskSearInp"
                                name="endDate"
                                value={formData.endDate}
                                onChange={(e) => handleTaskChange(e)}
                            />
                        </div>
                    </div>

                    <div className="taskMainInpDiv">
                        {/* start time */}
                        <div className="taskTabInps">
                            <input
                                type="time"
                                className="taskDateTimeInp"
                                name="startTime"
                                value={formData.startTime}
                                onChange={(e) => handleTaskChange(e)}
                            />
                        </div>

                        {/* end time */}
                        <div className="taskTabInps">
                            <input
                                type="time"
                                className="taskDateTimeInp"
                                name="endTime"
                                value={formData.endTime}
                                onChange={(e) => handleTaskChange(e)}
                            />
                        </div>
                    </div>

                    {/* Task Name */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            placeholder={language.task_name}
                            className="taskUpperInp"
                            name="taskName"
                            value={formData.taskName}
                            onChange={(e) => handleTaskChange(e)}
                        />
                    </div>

                    {/* Task Notes */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            placeholder={language.task_nate}
                            className="taskUpperInp"
                            name="taskNote"
                            value={formData.taskNote}
                            onChange={(e) => handleTaskChange(e)}
                        />
                    </div>

                    {/* Task Status */}
                    <div className="taskMainInpDiv">
                        <select
                            className="taskUpperInp"
                            name="taskStatus"
                            value={formData.taskStatus}
                            onChange={(e) => handleTaskChange(e)}
                        >
                            <option value="" disabled>
                                {language.task_select}
                            </option>
                            <option value="open">{language.open}</option>
                            <option value="doing">{language.doing}</option>
                            <option value="done">{language.done}</option>
                            <option value="ideas">{language.ideas}</option>
                            <option value="onhold">{language.on_hold}</option>
                        </select>
                    </div>

                    {/* Assign To User */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder="Assign to User(Select)"
                            isClearable={true}
                            isSearchable={true}
                            isMulti={true}
                            name="assignedUser"
                            options={selectAssignUserMemo}
                            value={formData.assignedUser}
                            onChange={(selectedOptions) => {
                                setFormData(prev => ({
                                    ...prev,
                                    assignedUser: selectedOptions || []
                                }));
                            }}
                        />
                    </div>

                    {/* Hidden select for non-main users */}
                    {isMainUserMemo && (
                        <div className="taskMainInpDiv" style={{ display: 'none' }}>
                            <Select
                                className="taskUpperInpSearch"
                                placeholder="Assign to User(Select)"
                                isClearable={true}
                                isSearchable={true}
                                name="assignedUser"
                                options={selectAssignUserMemo}
                                onChange={(e) => {
                                    if (e) {
                                        setFormData(prev => ({ ...prev, assignedUser: [e] }));
                                    } else {
                                        setFormData(prev => ({ ...prev, assignedUser: [] }));
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Assign To Project */}
                    <div className="taskMainInpDiv">
                        <select
                            className="taskUpperInp"
                            name="assignedProject"
                            value={formData.assignedProject}
                            onChange={(e) => handleTaskChange(e)}
                        >
                            <option value="" disabled>
                                {language.assign_to_project}
                            </option>
                            {assignProjectData?.map((item, i) => (
                                <option key={i} value={item?._id}>{item?.projectName}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="postTaskBtnDiv">
                    {
                        !isEdit ? (
                            <button onClick={(e) => handlePost(e)}>
                                {language.post}
                            </button>
                        ) : (
                            <button onClick={(e) => handleUpdate(e)}>
                                {language.Update}
                            </button>
                        )
                    }
                </div>
            </form>

            {/* drop to calender */}
            <div className="orDrFigDiv">
                <p className="orDrText">{language.Or_drop_to_calendar}</p>
                <figure className="fisiDrIconFig">
                    <img src={fisiIconDrop} alt="..." />
                </figure>
            </div>

            {/* quick view */}
            {taskAllData?.length !== 0 && (
                <div className="quickMainViewDiv">
                    <p className="ouickViewHead">{language.quick_view}</p>
                    <div className="quickViewUlDiv">
                        <ul style={{ maxHeight: "345px" }} className="quickViewUl">
                            {taskAllData?.map((item, i) => (
                                <li
                                    key={i}
                                    className="quickViewLi"
                                    onClick={() => {
                                        setModala(true);
                                        setTaskDetailData(item)
                                    }}
                                >
                                    <div>
                                        <p className="quickAnsText">{item?.taskName}</p>
                                        <div className="quickDoneTextDiv">
                                            <p className="quickDoneText quickGreenDoneDot">
                                                {item?.taskStatus}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="quickViewActions">
                                        <figure className="quickFirstIconFig">
                                            <img src={fisiIconDrop} alt="..." />
                                        </figure>
                                        <button
                                            className="deleteProjectBtn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteClick(item);
                                            }}
                                            title={language.Delete_Task}
                                        >
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}


            {/* Delete Confirmation Modal */}
            {deleteModalOpen && (
                <div className="delete-modal-overlay">
                    <div className="delete-modal-content">
                        <div className="delete-modal-header">
                            <h3>Delete Task</h3>
                            <button
                                className="delete-modal-close"
                                onClick={() => {
                                    setDeleteModalOpen(false);
                                    setProjectToDelete(null);
                                    setDeleteConfirmText('');
                                }}
                                disabled={deleting}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="delete-modal-body">
                            <p>
                                {language.Delete_Task_PopUp_Body1} <strong>"{projectToDelete?.taskName}"</strong>?
                                {language.Delete_Task_PopUp_Body2}
                            </p>
                            <p>
                                Type <strong>delete</strong> to confirm:
                            </p>
                            <input
                                type="text"
                                className="delete-confirm-input"
                                value={deleteConfirmText}
                                onChange={(e) => setDeleteConfirmText(e.target.value)}
                                placeholder="Type 'delete' here"
                                disabled={deleting}
                            />
                        </div>
                        <div className="delete-modal-footer">
                            <button
                                className="delete-modal-cancel"
                                onClick={() => {
                                    setDeleteModalOpen(false);
                                    setProjectToDelete(null);
                                    setDeleteConfirmText('');
                                }}
                                disabled={deleting}
                            >
                                Cancel
                            </button>
                            <button
                                className="delete-modal-confirm"
                                onClick={confirmDelete}
                                disabled={deleteConfirmText.toLowerCase() !== 'delete' || deleting}
                            >
                                {deleting ? 'Deleting...' : 'Delete Task'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default TaskSidebar;
